import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { ArrowLeft, Info } from "lucide-react";

const RechtlicherHinweis = () => {
  return (
    <>
      <Helmet>
        <title>Rechtlicher Hinweis | Jörg Hörmann Coaching & Consulting</title>
        <meta
          name="description"
          content="Rechtlicher Hinweis zur Coaching-Tätigkeit von Jörg Hörmann: Abgrenzung zu Anlageberatung, Produktvermittlung, Rechts- und Steuerberatung."
        />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://joerg-hoermann.de/rechtlicher-hinweis" />
      </Helmet>

      <div className="container max-w-3xl mx-auto px-4 py-16 sm:py-24">
        <Link
          to="/"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-primary transition-colors mb-10"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Zurück zur Startseite
        </Link>

        <div className="flex items-start gap-4 mb-8">
          <div className="flex-shrink-0 mt-1 p-2 rounded-full bg-muted/50">
            <Info className="h-5 w-5 text-muted-foreground" />
          </div>
          <h1 className="text-2xl sm:text-3xl font-heading font-bold text-foreground">
            Rechtlicher Hinweis
          </h1>
        </div>

        <div className="prose max-w-none dark:prose-invert text-muted-foreground leading-relaxed space-y-6">
          <p>
            Meine Tätigkeit umfasst ausschließlich Coaching und prozessbegleitende Beratung.
          </p>

          <p>Es erfolgt ausdrücklich <strong>keine</strong>:</p>

          <ul className="space-y-2">
            <li>Vermittlung von Finanz- oder Versicherungsprodukten</li>
            <li>Anlageberatung zu konkreten Finanzinstrumenten (z.&nbsp;B. ISIN/WKN)</li>
            <li>Rechts- oder Steuerberatung</li>
            <li>
              Ausübung von Heilkunde im Sinne der klinischen Psychotherapie oder
              Psychologie
            </li>
          </ul>

          <p>
            Die berücksichtigten Erkenntnisse der Finanzpsychologie dienen der
            persönlichen Weiterentwicklung und Selbstregulation.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <p className="text-sm text-muted-foreground">
            Weitere rechtliche Informationen finden Sie im{" "}
            <Link to="/impressum" className="text-primary hover:underline underline-offset-4">
              Impressum
            </Link>
            , in den{" "}
            <Link to="/agb" className="text-primary hover:underline underline-offset-4">
              AGB
            </Link>{" "}
            und in der{" "}
            <Link to="/datenschutz" className="text-primary hover:underline underline-offset-4">
              Datenschutzerklärung
            </Link>
            .
          </p>
        </div>
      </div>
    </>
  );
};

export default RechtlicherHinweis;
